export enum EnumAutomatedBreak {
  Yes = 'Yes',
  No = 'No'
}
